/**
 * Digital Advisor Solutions Service API 1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Observable } from 'rxjs';
import { AjaxRequest } from 'rxjs/observable/dom/AjaxObservable';
//@ts-ignore
// import * as models from '../model/models';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { ObjectUtils } from '@assetmark/ui-kit/dist/utils/object.utils';


import { AddUpdateContractApplicationInfo } from '../model/addUpdateContractApplicationInfo';
import { IApplicationState } from '../model/iApplicationState';

import {
	DasApiClient as ApiClient
	
} from '../../../apis/api.client';

// import isNotNullable = ObjectUtils.isNotNullable;

type TQueryParam = {
	key: string,
	value: string | string[] | boolean | number | Date | undefined,
}


// eslint-disable-next-line @typescript-eslint/no-namespace 
export namespace PreferenceService {
	/**
	* 
		* @summary Remove advisor photo.
	* @param agentId - The agent identifier i.e &#x3D; AG1634
	*/
	export function apiDasV1PreferenceAgentAgentIdAdvisorphotoDelete(agentId: string, customHeaders: Object = {}): Observable<RemoteData<boolean>> {
		const path = `/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/advisorphoto`.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'delete',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1PreferenceAgentAgentIdAdvisorphotoDelete(agentId: string, ): string {
		const path = '/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/advisorphoto'.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Upload the advisor photo.
	* @param agentId - The agent identifier i.e &#x3D; AG1634
	* @param file - 
	*/
	export function apiDasV1PreferenceAgentAgentIdAdvisorphotoPost(agentId: string, file?: Blob, customHeaders: Object = {}): Observable<RemoteData<IApplicationState>> {
		const path = `/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/advisorphoto`.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		headers = Object.assign({}, headers, {"Content-Type": "application/x-www-form-urlencoded" }) ;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			body: { 'file': file, },
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1PreferenceAgentAgentIdAdvisorphotoPost(agentId: string, file?: Blob, ): string {
		const path = '/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/advisorphoto'.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Get advisor pagesetting.
	* @param agentId - The agent identifier.AG1634
	*/
	export function apiDasV1PreferenceAgentAgentIdPagesettingGet(agentId: string, customHeaders: Object = {}): Observable<RemoteData<{ [key: string]: string; }>> {
		const path = `/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/pagesetting`.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1PreferenceAgentAgentIdPagesettingGet(agentId: string, ): string {
		const path = '/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/pagesetting'.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Updates the advisor preferences.
	* @param agentId - The agent identifier.
	* @param body - The request.
	*/
	export function apiDasV1PreferenceAgentAgentIdPreferencesPost(agentId: string, body?: AddUpdateContractApplicationInfo, customHeaders: Object = {}): Observable<RemoteData<IApplicationState>> {
		const path = `/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/preferences`.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1PreferenceAgentAgentIdPreferencesPost(agentId: string, body?: AddUpdateContractApplicationInfo, ): string {
		const path = '/api/das/v1/Preference/agent/${encodeURIComponent(String(agentId))}/preferences'.replace(/^\//, '').replace('{' + 'agentId' + '}', String(agentId));
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
}
